import {
  LEARNINGPATHID,
  LEARNINGPATHNAME,
  SAVE_TAGS,
} from "redux/constants/LearnerPathConstants";

const INITIAL_STATE = {
  LearningPathID: "",
  LearningPathName: "",
  tags: [],
};

const LearnerPathReducers = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LEARNINGPATHID:
      return { ...state, LearningPathID: action.payload };
    case LEARNINGPATHNAME:
      return { ...state, LearningPathName: action.payload };
    case SAVE_TAGS:
      return { ...state, tags: action.payload };
    default:
      return state;
  }
};

export default LearnerPathReducers;
